const POSITION = {
  LEFT_BOTTOM: 'c',
  CENTER_BOTTOM: 'c2',
  RIGHT_BOTTOM: 'c3',
  RIGHT_CENTER: 'c4',
  LEFT_CENTER: 'c5',
  LEFT_TOP: 'c6',
  CENTER_TOP: 'c7',
  RIGHT_TOP: 'c8'
}

export default { POSITION }
